/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { all, fork, call } from 'redux-saga/effects';

import { watchOnSetTheme } from './ui.saga';
import { watchOnSetToastNotification } from './notification-ui.saga';
import { watchOnSetSettings, watchOnSaveSettings, watchOnGetSettings } from './settings.saga';
import { watchOnGetPermissionsByApplication } from './permissions.saga';
import { watchOnGetUserLicenses, watchOnGetUserPermissionsByApplication } from './user.saga';
import { watchOnGetRoles, watchOnDeleteRoles } from './roles.saga';
import { watchOnSetConfig } from './config.saga';
import { watchOnGetCustomRolesLimit } from './appconfig.saga';

export default function * rootSaga() {
  yield all([
    fork(watchOnSetTheme),
    fork(watchOnSetToastNotification),
    fork(watchOnSetSettings),
    fork(watchOnSaveSettings),
    fork(watchOnGetSettings),
    fork(watchOnGetPermissionsByApplication),
    fork(watchOnGetUserLicenses),
    fork(watchOnGetRoles),
    fork(watchOnDeleteRoles),
    fork(watchOnSetConfig),
    fork(watchOnGetUserPermissionsByApplication),
    fork(watchOnGetCustomRolesLimit),
  ]);
}
